export default __webpack_public_path__ + "static/media/forward.ff39da98.svg";